(function () {
  function enhanceTurkeyTailReview() {
    var root = document.querySelector('.tt-review-summary--yotpo');
    if (!root || root.classList.contains('tt-review-enhanced')) return;

    var ratingText = root.querySelector('.sr-only');
    var countLink = root.querySelector('.text-m');
    if (!ratingText || !countLink) return;

    var ratingMatch = ratingText.textContent.match(/([0-5](?:\.\d+)?)/);
    var countMatch = countLink.textContent.match(/([\d,]+)/);
    if (!ratingMatch || !countMatch) return;

    var rating = Math.max(0, Math.min(5, parseFloat(ratingMatch[1])));
    var display = document.createElement('div');
    display.className = 'tt-review-dynamic-display';
    display.setAttribute('aria-label', rating + ' out of 5 stars, ' + countMatch[1] + ' reviews');

    var stars = document.createElement('span');
    stars.className = 'tt-review-dynamic-stars';
    stars.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < 5; i += 1) {
      var fill = Math.max(0, Math.min(100, (rating - i) * 100));
      var star = document.createElement('span');
      star.className = 'tt-review-dynamic-star';
      star.style.setProperty('--tt-star-fill', fill + '%');
      star.textContent = '★';
      stars.appendChild(star);
    }

    var score = document.createElement('strong');
    score.className = 'tt-review-dynamic-score';
    score.textContent = rating.toFixed(1);

    var count = document.createElement('a');
    count.className = 'tt-review-dynamic-count';
    count.href = '#';
    count.textContent = '(' + countMatch[1] + ' Reviews)';
    count.addEventListener('click', function (event) {
      event.preventDefault();
      countLink.click();
    });

    display.appendChild(stars);
    display.appendChild(score);
    display.appendChild(count);
    root.appendChild(display);
    root.classList.add('tt-review-enhanced');
  }

  function startTurkeyTailReview() {
    enhanceTurkeyTailReview();
    var root = document.querySelector('.tt-review-summary--yotpo');
    if (!root) return;
    var observer = new MutationObserver(enhanceTurkeyTailReview);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startTurkeyTailReview);
  } else {
    startTurkeyTailReview();
  }
}());
